import { MisconfigurationsSideMenuWebComponent } from './component/MisconfigurationsSideMenuWebComponent';

export { MisconfigurationsSideMenuWebComponent };
